import { includes } from "lodash";

export function translateNFSEStatus(status: string): string {
	if (status === "canceled") return "Cancelada";
	if (status === "incancellation") return "Em cancelamento";
	if (status === "unprocessed") return "Não processada";
	if (["rejectted", "unauthorized", ""].includes(status)) return "Não autorizada";
	if (["issued", "authorized", ""].includes(status)) return "Emitida";
	if (["requested", "requested", ""].includes(status)) return "Em processamento";
	if (["", "open", undefined, null].includes(status)) return "A emitir";

	return status;
}
